import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';
import { IWorkshopAssessments } from 'models/workshopAssessments';



interface Props {
  open: boolean;
  loading: boolean;
  workshopAssessment: IWorkshopAssessments;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditWorkshopAssessment: React.FC<Props> = ({ open, loading, workshopAssessment, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation();

  let basicFields: IFormField[] = [
    {
      name: 'timeToComplete',
      label: t('T_time_to_complete'),
      type: InputTypes.NUMBER,
      placeholder: t('T_time_to_complete'),
      defaultValue: workshopAssessment.timeToComplete,
      internalLabel: true,
      required: true
    },
    {
      name: 'active',
      label: t('T_active'),
      type: InputTypes.SWITCH,
      defaultValue: workshopAssessment.active,
      internalLabel: true,
      required: true
    },
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_workshop_assessment')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditWorkshopAssessment;
